class GoogleTagManagerService
  constructor: ($window, ConfigService) ->
    @$window       = $window
    @ConfigService = ConfigService
    @eventData = {}

  # NEW 
  # * (the 'fireEvent' function fires an event to GTM with additional data via the 2nd argument)
  # * (the namespace given in the 3rd arg allows additional event data to be attached)
  # * (data accumulates in a namespace via 'extendEventData', but it is NOT sent to GTM at that time)
  # * (data is only sent to GTM via fireEvent (NEW), or sendProperties (LEGACY))
  fireEvent: (eventName, data={}, eventDataNamespace=null) ->
    newDataLayerItem = { event: eventName }
    if eventDataNamespace?
      angular.extend(newDataLayerItem, (@eventData[eventDataNamespace] || {}))
    angular.extend(newDataLayerItem, data)
    @pushToDataLayer(newDataLayerItem)

  # Two events (ex: application_pageview, application_pagesubmit) may want to attach the same data
  # when fired, this common shared data is the eventData "namespace" (ex: application_page)
  extendEventData: (namespace, data={}) ->
    @eventData[namespace] ||= {}
    angular.extend(@eventData[namespace], data)

  # Pushing data to the dataLayer array sends data to GTM
  pushToDataLayer: (newDataLayerItem) ->
    if @ConfigService.googleTagManagerEnabled
      @$window.dataLayer ||= []
      if Array.isArray(@$window.dataLayer)
        @$window.dataLayer.push newDataLayerItem

  # LEGACY (uses a single shared event data namespace 'legacy')
  sendProperties: (data) ->
    @pushToDataLayer(
      angular.extend(data, (@eventData['legacy'] || {}))
    )

angular
.module("avant.googleTagManager")
.service("GoogleTagManagerService", [
  "$window",
  "ConfigService",
  GoogleTagManagerService
])

if typeof exports != 'undefined'
  if typeof module != 'undefined' && module.exports
    exports = module.exports = GoogleTagManagerService
  exports.GoogleTagManagerService = GoogleTagManagerService
else
  window.GoogleTagManagerService = GoogleTagManagerService
